import {
  CloseOutlined,
  DeleteOutlined,
  DownOutlined,
  MoreOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { Button, Dropdown, Menu, MenuProps, Space } from "antd";
import React, { useCallback } from "react";
import { MdDelete, MdOutlineAdd } from "react-icons/md";

interface HeaderActionsProps {
  isBulkEditMode: boolean;
  isSmallScreen: boolean;
  selectedTopicCount: number;
  onToggleBulkEditMode: () => void;
  onBulkDelete: () => void;
  onImportTopics: () => void;
  onNewTopic: () => void;
  onNewCategory: () => void;
  canEditBusiness: boolean;
}

export const HeaderActions: React.FC<HeaderActionsProps> = ({
  isBulkEditMode,
  isSmallScreen,
  selectedTopicCount,
  onToggleBulkEditMode,
  onBulkDelete,
  onImportTopics,
  onNewTopic,
  onNewCategory,
  canEditBusiness,
}) => {
  const standardMenuItems = useCallback(
    () => (
      <Menu>
        {canEditBusiness && (
          <Menu.Item
            key="bulk-add"
            onClick={onImportTopics}
            icon={<UploadOutlined />}
          >
            Bulk Add Topics
          </Menu.Item>
        )}
        {canEditBusiness && (
          <Menu.Item
            key="bulk-delete"
            onClick={onToggleBulkEditMode}
            icon={<MdDelete />}
          >
            Bulk Delete Topics
          </Menu.Item>
        )}
        {canEditBusiness && (
          <Menu.Item
            key="new-category"
            onClick={onNewCategory}
            icon={<MdOutlineAdd />}
          >
            New Category
          </Menu.Item>
        )}
        <Menu.Item key="new-topic" onClick={onNewTopic} icon={<MdOutlineAdd />}>
          New Topic
        </Menu.Item>
      </Menu>
    ),
    [
      onToggleBulkEditMode,
      onImportTopics,
      onNewTopic,
      onNewCategory,
      canEditBusiness,
    ]
  );

  const bulkActionMenuItems: MenuProps["items"] = [];

  if (canEditBusiness) {
    bulkActionMenuItems.push({
      key: "bulk-add",
      label: "Bulk Add Topics",
      icon: <UploadOutlined />,
      onClick: onImportTopics,
    });
    bulkActionMenuItems.push({
      key: "bulk-delete",
      label: "Bulk Delete Topics",
      icon: <MdDelete />,
      onClick: onToggleBulkEditMode,
    });
  }

  if (isBulkEditMode) {
    return (
      <Space>
        <Button icon={<CloseOutlined />} onClick={onToggleBulkEditMode}>
          Cancel
        </Button>
        <Button
          danger
          type="primary"
          icon={<DeleteOutlined />}
          onClick={onBulkDelete}
          disabled={selectedTopicCount === 0 || !canEditBusiness}
        >
          Delete Selected ({selectedTopicCount})
        </Button>
      </Space>
    );
  } else if (isSmallScreen) {
    return (
      <Dropdown overlay={standardMenuItems()} placement="bottomRight">
        <Button icon={<MoreOutlined />} />
      </Dropdown>
    );
  } else {
    return (
      <Space>
        <Dropdown
          menu={{ items: bulkActionMenuItems }}
          placement="bottomLeft"
          trigger={["click"]}
        >
          <Button>
            Bulk Actions <DownOutlined />
          </Button>
        </Dropdown>
        {canEditBusiness && (
          <Button onClick={onNewCategory} icon={<MdOutlineAdd />}>
            New Category
          </Button>
        )}
        <Button type="primary" onClick={onNewTopic} icon={<MdOutlineAdd />}>
          New Topic
        </Button>
      </Space>
    );
  }
};
